import {
  UPDATE_SOFTSKILLS_USER,
  UPDATE_SOFTSKILLS_USER_SUCCESS,
  UPDATE_SOFTSKILLS_USER_CLEAN,
  UPDATE_SOFTSKILLS_USER_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  course: undefined,
}

const SoftskillsUserUpdate = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SOFTSKILLS_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case UPDATE_SOFTSKILLS_USER_SUCCESS:
      state = {
        ...state,
        user: action.payload.user,
        loading: false,
        done: true,
      }
      break
    case UPDATE_SOFTSKILLS_USER_CLEAN:
      state = initialState
      break
    case UPDATE_SOFTSKILLS_USER_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftskillsUserUpdate
